<template>
  <div class="container p-0 mt-3 mt-md-5">

    <div class="row gold justify-content-center mb-3">
      <h2>
        <i class="fas fa-comment mr-1"></i>
        <span v-text="this.$route.meta.title"></span>
      </h2>
    </div>


    <div class="card">
      <div class="row g-0">
        <Coaches
          :coaches="coaches"
          :members="members"
          :connections="connections"
          :selectedCoach="selectedCoach"
        ></Coaches>

        <div class="col-12 col-lg-8 col-xl-9 d-flex flex-column messages-container">
          <div class="py-2 px-4 border-bottom d-none d-lg-block">
            <div class="d-flex align-items-center py-1">
              <div class="position-relative">
                <img :src="selectedCoach?.profile_image" class="rounded-circle mr-1" :alt="selectedCoach?.first_name" width="40" height="40" />
              </div>
              <div class="flex-grow-1 pl-3">
                <strong>{{ selectedCoach?.first_name }} {{ selectedCoach?.last_name }}</strong>
                <div class="text-muted small" v-if="selectedCoach?.summary && selectedCoach?.summary !== 'null'">
                  <em>{{ selectedCoach.summary}}</em>
                </div>
              </div>
            </div>
          </div>
          <div class="position-relative flex-grow-1" ref="chatbox" style="overflow-y: auto">
            <div class="d-flex justify-content-center mt-5" v-if="loading.messages">
              <div class="spinner-border" role="status"></div>
            </div>
            <div v-else>
              <div class="pt-3 text-center text-black-50" style="font-style: italic" v-if="! messages?.length">
                This conversation is empty
              </div>
            </div>
            <Messages
              :messages="messages"
              :hasMore="hasMore"
              :coach="selectedCoach"
              @loadMore="getMessages(true)"
            ></Messages>
          </div>
          <div class="flex-grow-0 py-3 px-4 border-top">
            <div class="d-flex flex-column flex-sm-row align-items-end">
              <input v-model="message" @keyup.enter="sendMessage()" type="text" class="form-control" placeholder="Type your message" />
              <button class="btn btn-primary" @click="sendMessage()">Send</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Messages from "@/components/Chatbox/Messages";
import Coaches from "@/components/Chatbox/Coaches";

export default {
  components: {
    Coaches,
    Messages
  },
  watch:{
    $route () {
      this.selectCoach()
    }
  },
  computed: {
    profile() {
      return this.$store.state.profile;
    },
  },
  created: function() {
    this.getMembers()
  },
  data() {
    return {
      selectedCoach: null,
      coaches: undefined,
      connections: undefined,
      members: undefined,
      messages: [],
      message: '',
      loading: {messages: false},
      hasMore: false,
    }
  },
  methods: {

    sendMessage() {

      if (! this.message) {
        return
      }

      const message = this.message
      this.message = ''

      this.messages.push({
        message,
        sender_id: this.profile.id,
        receiver_id: this.selectedCoach.id,
        id: Date.now()
      })
      this.$nextTick(() => {
        this.$refs['chatbox'].scrollTop = this.$refs['chatbox'].scrollHeight
      })

      const url = `${this.$store.state.api_url}sendMessage`;
      const params = new URLSearchParams();
      params.append('token', this.$store.state.session_id);
      params.append('coachId', this.selectedCoach.id);
      params.append('message', message);

      this.loading.sendMessage = true

      axios({
        url,
        data: params,
        method: 'post',
      })
        .then(() => {
          this.loading.sendMessage = false
        })
    },

    getMembers: function () {
      const url = `${this.$store.state.api_url}getChatUsers?token=${this.$store.state.session_id}`;

      axios(url)
        .then((response) => {
          this.coaches = response.data.coaches ?? [];
          this.connections = response.data.connections ?? [];
          this.members = response.data.members ?? [];

          if (this.$route.params.coachId) {
            this.selectCoach()
            return
          }

          const defaultRecipient = this.getRecipient()
          if (defaultRecipient) {
            this.$router.push(`/chatbox/${defaultRecipient.id}`)
          }
        })
    },

    selectCoach() {
      this.selectedCoach = this.getRecipient(this.$route.params.coachId)

      if (this.selectedCoach) {
        this.messages = []
        this.getMessages()
      }
    },

    getMessages(loadMore) {
      const coachId = this.selectedCoach.id

      let params = `coachId=${coachId}&token=${this.$store.state.session_id}`

      if (loadMore) {
        const firstMsgId = this.messages.find(() => true)?.id
        params += `&cursor=${firstMsgId}`
      }

      const url = `${this.$store.state.api_url}getMessages?${params}`;

      this.loading.messages = true

      axios(url)
        .then((response) => {
          let messages = response.data.messages.reverse() || []
          this.hasMore = messages.length === response.data.limit

          if (loadMore) {
            messages = messages.concat(this.messages)
          }

          this.messages = messages
          this.loading.messages = false

          if (! loadMore) {
            this.$nextTick(() => {
              this.$refs['chatbox'].scrollTop = this.$refs['chatbox'].scrollHeight
            })
          }
        })
    },

    getRecipient(recipientId) {
      return this.connections.concat(this.coaches).concat(this.members)
        .find(({id}) => recipientId === undefined || id === recipientId)
    }
  }
}

</script>

<style scoped>

.messages-container {
  height: calc(100vh - 190px);
}

@media screen and (min-width: 992px) {
  .messages-container {
    height: calc(100vh - 120px);
  }
}


</style>
